module.exports = __webpack_public_path__ + "img/desktop_arrow_right.9bf23.png";